import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import HekProvider from './providers/hekProvider'
import EditorTest from './components/EditorTest';
import { positions, Provider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import Favicon from 'react-favicon';

const options = {
  timeout: 5000,
  position: positions.TOP_CENTER
};

ReactDOM.render( 
    <React.StrictMode>
    <Favicon url="./favicon.ico" />
    <Provider template={AlertTemplate} {...options}>
    <HekProvider>
    <EditorTest/>
    </HekProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);


reportWebVitals();